// extracted by mini-css-extract-plugin
export var activityContainer = "_mf-0";
export var typingIndicatorContainer = "_mf-1";
export var typingIndicatorDot = "_mf-2";
export var wave = "_mf-3";